module.exports = "<div bind-html-compile=\"alertsCtrl.template\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alertsCtrl/template.html
// module id = 1242
// module chunks = 0